const mapPostalCode = (res) => {
	const filterByPostalCode = res.map((item) => (item.address.postalCode ? item : { ...item, address: { ...item.address, postalCode: '00000' } }))
	return filterByPostalCode
}

const mapRemoveDefaultHouse = (res) => {
	const regexStart = /\s1(?=,)/
	const regexEnd = /\s1$/
	return res.map((item) => {
		const newTitle = item.title
			.replace(regexStart, '')
			.replace(regexEnd, '')
		const newLabel = item.address.label
			.replace(regexStart, '')
			.replace(regexEnd, '')
		return {
			...item,
			title: newTitle,
			address: {
				...item.address,
				label: newLabel,
				houseNumber: ''
			},
		}
	})
}

export const filterAutocompleteSearchResult = (res, removeDefaultHouse = false) => {
	const filteredByStreet = res.filter((item) => item.address.street)
	const filteredByPostalCode = mapPostalCode(filteredByStreet)
	if (!removeDefaultHouse) {
		return filteredByPostalCode
	}
	return mapRemoveDefaultHouse(filteredByPostalCode)
}
